/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/movie/layouts/desktop.app.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'movie/layouts/desktop.app', exports: {} };
const exports = module.exports;



import { Fandango_debugLog as debugLog } from '@take-2/fd-modules/splits/require-core';



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango as Fandango_pageDetails } from '@take-2/fd-modules/splits/require-core';

const { pageDetails } = Fandango_pageDetails;


const { loadReviews } = readPageContext(pageDetails)


import backgroundBlur from '@take-2/fd-modules/movie/shared/desktop/backgroundBlur';



import mopReviews from '@take-2/fd-modules/movie/shared/desktop/mopReviews';



import movieStateUI from '@take-2/fd-modules/movie/shared/desktop/movieStateUI';



import rottenTomatoes from '@take-2/fd-modules/movie/shared/desktop/rottenTomatoes';



import hearts from '@take-2/fd-modules/shared/utils/hearts';

function readPageContext(pageDetails) {
    return {
        loadReviews: pageDetails && pageDetails.loadReviews
    };
}
function run() {
    checkDependencies(module.name, debugLog);
    if (loadReviews) {
        mopReviews.init();
    }
    movieStateUI.run();
    backgroundBlur.init();
    rottenTomatoes.init();
    hearts.init();
}
run();
export default {  };